import { createSelector } from '@ngrx/store';

export const selectCurrencyState = (state: any) => state.currencyList;

export const selectCurrencyList = createSelector(
  selectCurrencyState,
  (state): string[] => state,
);
